module.exports = {
    DOCUMENT:           'doc',
    TEXT:               'unstyled',

    CODE:               'code_block',
    BLOCKQUOTE:         'blockquote',
    PARAGRAPH:          'paragraph',
    FOOTNOTE:           'footnote',
    HTML:               'html_block',
    HR:                 'hr',

    HEADING_1:          'header_one',
    HEADING_2:          'header_two',
    HEADING_3:          'header_three',
    HEADING_4:          'header_four',
    HEADING_5:          'header_five',
    HEADING_6:          'header_six',

    TABLE:              'table',
    TABLE_ROW:          'table_row',
    TABLE_CELL:         'table_cell',

    OL_LIST:            'ordered_list',
    UL_LIST:            'unordered_list',

    LIST_ITEM:          'list_item'
};



//////////////////
// WEBPACK FOOTER
// ../~/markup-it/lib/constants/blocks.js
// module id = 74
// module chunks = 0